import { render, staticRenderFns } from "./HelpStandardProjects.vue?vue&type=template&id=4dd39d3b&"
import script from "./HelpStandardProjects.vue?vue&type=script&lang=ts&"
export * from "./HelpStandardProjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports